import { useUtilsStore } from '../components/Contexts/UtilsContext'
import { useActivityStore } from '../components/Contexts/ActivityContext'
import { useEffect, useState } from 'react'

const useFullscreenImage = (): string | undefined => {
  const lastbotActivity = useActivityStore((state) => state.lastBotActivity)
  const fullScreenImage = useUtilsStore((state) =>state.fullScreenImage)
  const [image, setImage] = useState<string | undefined>(undefined)

  useEffect(() => {
    setImage(fullScreenImage)
  }, [fullScreenImage])

  useEffect(() => {
    if (
      lastbotActivity &&
      lastbotActivity.type === 'event' &&
      lastbotActivity.name === 'hospitality.ShowImage' &&
      lastbotActivity.value
    ) {
      setImage(lastbotActivity.value)
    } else {
      setImage(undefined)
    }
  }, [lastbotActivity])

  return image
}

export default useFullscreenImage
